export const API = process.env.REACT_APP_BACKEND_URL;
export const PUB = `${API}/api/public/franchise`;

export const inr = (paise) => {
  if (paise === null || paise === undefined) return "—";
  const r = paise / 100;
  return "₹" + r.toLocaleString("en-IN", { maximumFractionDigits: Number.isInteger(r) ? 0 : 2 });
};

export const STATUS_LABEL = {
  KNOWN: "Known", REFERENCE_PENDING: "Reference — awaiting confirmation", TBC: "To be confirmed",
  INCLUDED: "Included", VARIABLE: "Variable", ILLUSTRATIVE: "Illustrative",
  AWAITING_ESTIMATE: "Awaiting estimate", ESTIMATE: "Estimate", PROPOSED_BUDGET: "Your proposed budget",
};

export const FREQ_LABEL = {
  ONE_TIME: "One time", MONTHLY: "Monthly", SIX_MONTHS: "Per 6 months", PER_CAMPAIGN: "Per campaign",
  AS_SCOPED: "As scoped", AS_APPROVED: "As approved", AS_INCURRED: "As incurred", ONGOING: "Ongoing",
};

export const CHARGE_LABEL = {
  ONE_TIME: "One-time fee", PER_UNIT_MONTHLY: "Monthly per unit", FIXED_MONTHLY: "Fixed monthly",
  SHARED_POOL: "Shared cost allocation", ACTUAL: "Actual cost", TBC: "To be confirmed",
  INCLUDED: "Included — no separate charge", STAFFING_SIX_MONTH: "Per sourced employee / 6 months",
};

export const taxLabel = (t) => {
  if (!t) return "—";
  if (t.status === "NOT_APPLICABLE") return "N/A";
  if (t.rate_bp !== null && t.rate_bp !== undefined) return `${t.status === "INCLUSIVE" ? "Incl." : "Excl."} ${t.rate_bp / 100}%`;
  return t.status === "EXCLUSIVE_RATE_PENDING" ? "GST extra · rate pending" : "Tax pending";
};

export const EMPTY_CONFIG = {
  location: { city: "", state: "", property_status: "", area_sqft: "", monthly_rent: "" },
  format_id: "", model_id: "", acknowledgements: {}, responses: {}, staffing: [],
  scenario: { gross_sales_monthly: "" }, meta_ads_budget: "",
};

export const postJSON = async (url, body) => {
  const r = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    const d = data.detail;
    const msg = typeof d === "string" ? d : d?.message ? `${d.message}${d.errors ? ": " + d.errors.map((e) => e.message).join("; ") : ""}` : `Request failed (${r.status})`;
    throw new Error(msg);
  }
  return data;
};

export const downloadPost = async (url, body, filename) => {
  const r = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  if (!r.ok) throw new Error(`Download failed (${r.status})`);
  const blob = await r.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
};

export const optionalServicesFor = (catalogue, modelId) =>
  (catalogue?.services || []).filter((s) => s.enabled !== false && s.applicability?.[modelId] === "OPTIONAL");

export const missingResponses = (catalogue, config) =>
  optionalServicesFor(catalogue, config.model_id).filter((s) => {
    const v = config.responses?.[s.id];
    return v === undefined || v === "" || v === null;
  });
